import { forwardRef } from "react";

import { TextStyled } from "./Text.styles";
import { TTextProps, TTextRef } from "./Text.types";

const Text = forwardRef<TTextRef, TTextProps>(function Text({ weight = "base", variant = "base", ...rest }, ref) {
  return (
    <TextStyled
      ref={ref}
      $weight={weight}
      $variant={variant}
      {...rest}
    />
  );
});

export default Text;
